import { implementCallback, generateCallback } from '../util/appCallback';
import invoking from '../util/invoking';
import Cookies from 'js-cookie';
import { nanoid } from 'nanoid';

function ensureUnifiedDeviceId() {
    // step 1: 客户端会自己处理设备 id（如果获取用户授权，就使用系统的，否则自己生成一个），并种到 webview 上
    let appGenerateDeviceId = Cookies.get('pt_open_mmid');

    if (!appGenerateDeviceId) {
        appGenerateDeviceId = nanoid();
        // 如果没有自己搞一个
        Cookies.set('pt_open_mmid', appGenerateDeviceId, {
            expires: 200 * 365, /// 200 years
        });

        // 移除旧的 pt_device_id
        Cookies.remove('pt_device_id');
    }

    return appGenerateDeviceId;
}

// 获取UID、设备号、广告标识iOS（idfa）
export function getDeviceID(option) {
    invoking({
        action: 'fetchDeviceID',
        option,
    });
}

// 获取归一化的设备号，不管什么乱七八糟的 deviceId / idfa / imei / oaid
// 在前端都会统一成一个独立的设备 id，用于标记设备
export function getUnifiedDeviceID(option) {
    implementCallback(
        {
            code: 0,
            data: {
                deviceId: ensureUnifiedDeviceId(),
            },
        },
        option
    );
}

// 获取网络状态
export function getNetworkType(option) {
    if (this.networkStatus) {
        const globalMethodName = generateCallback(option, (networkType) => {
            const result = {
                code: -1,
                data: {
                    networkType: '',
                },
            };
            // IOS 孕管 6.1.04 无网络时返回 '0'
            // IOS 轻聊 8.1.0 无网络时返回最近的网络状态
            // 还会未知，无，等不统一错误情况。
            if (!networkType || parseInt(networkType) === 0) {
                // 未知情况
            } else {
                result.code = 0;
                result.data.networkType = networkType;
            }
            return result;
        });
        this.networkStatus({
            jsmethod: globalMethodName,
        });
    }
}
// 震动
export function shortVibrate(option) {
    if (this.vibrate) {
        this.vibrate();
        implementCallback({ code: 0 }, option);
    }
}

export default {
    getDeviceID,
    getUnifiedDeviceID,
    getNetworkType,
    shortVibrate,
};
